<app-titulo texto="Pesquisa de Satisfação"></app-titulo>
<div class="w-full text-center text-md font-opensans text-700 mt-8">
  <p-messages [(value)]="error" [enableService]="false" [closable]="false" />
</div>
